export const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return "";

    // Create a Date object from the input string
    const date = new Date(dateString);

    // Format the date in EST time zone
    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York", // EST time zone
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // Use 12-hour format with AM/PM
    });

    const formattedDateParts = formatter.formatToParts(date);

    // Parse and rearrange formatted parts into the desired format
    const day = formattedDateParts.find(part => part.type === "day")?.value || "00";
    const month = formattedDateParts.find(part => part.type === "month")?.value || "00";
    const year = formattedDateParts.find(part => part.type === "year")?.value || "0000";
    const hour = formattedDateParts.find(part => part.type === "hour")?.value || "00";
    const minute = formattedDateParts.find(part => part.type === "minute")?.value || "00";
    const dayPeriod = formattedDateParts.find(part => part.type === "dayPeriod")?.value || "";

    return `${day}/${month}/${year} ${hour}:${minute} ${dayPeriod}`;
};
